import { useFinanceApi } from 'infrastructure/api';

const useBudgetCategorySuggestionService = () => {
  const { sendPostRequest } = useFinanceApi();

  const suggestBudgetCategories = async (date: any, accountId: any) => {
    const response = await sendPostRequest(`/budgets/structures/categories/search`, {
      date,
      accountId,
    });
    const suggestions = await response.json();

    return { result: suggestions.categories };
  };

  return {
    suggestBudgetCategories,
  };
};

export default useBudgetCategorySuggestionService;
